import { Paper, Title, Text, Badge, Group, Stack, Grid, Box } from "@mantine/core";
import { IconCircleCheck, IconAlertCircle } from "@tabler/icons-react";
import ContrastSensitivityChart from "../../testContainer/common/ContrastSensitivityChart";

interface ContrastTestCardProps {
  test: any;
}

export function ContrastTestCard({ test }: ContrastTestCardProps) {
  if (!test.hasContrastData || !test.contrastResults) return null;

  return (
    <Grid gutter="md">
      <Grid.Col span={4}>
        <Stack gap="md">
          <Group>
            <Title order={4}>{test.title}</Title>
            {test.status === "normal" ? (
              <Badge color="green" variant="filled" leftSection={<IconCircleCheck size={14} />}>
                Normal
              </Badge>
            ) : (
              <Badge color="orange" variant="filled" leftSection={<IconAlertCircle size={14} />}>
                Attention
              </Badge>
            )}
          </Group>
          <Text c="dimmed" size="sm">
            {test.description}
          </Text>

          <Paper
            withBorder
            p="sm"
            radius="md"
            bg="var(--oculera-tint-blue)"
            style={{ borderColor: "var(--mantine-color-blue-3)" }}
          >
            <Text size="xs" c="blue.7" fw={600} mb="xs">
              Score
            </Text>
            <Text size="xl" c="blue.7" fw={700}>
              {test.score}
            </Text>
          </Paper>

          <Box>
            <Text size="sm" fw={600} mb="xs">
              Results
            </Text>
            <Text size="sm" c="dimmed">
              {test.details}
            </Text>
          </Box>

          <Box>
            <Text size="sm" fw={600} mb="xs">
              Recommendation
            </Text>
            <Text size="sm" c="dimmed">
              {test.recommendation}
            </Text>
          </Box>
        </Stack>
      </Grid.Col>

      <Grid.Col span={8}>
        <ContrastSensitivityChart data={test.contrastResults} />
      </Grid.Col>
    </Grid>
  );
}
